import type { Production } from '@/domain/entities/production.entity'
import type { ProductionDto } from './production.dto'

export const productionMapper = {
  toProduction(dto: ProductionDto): Production {
    return {
      id: dto.id,
      outletId: dto.outlet_id,
      recipeId: dto.recipe_id,
      recipeName: dto.recipe_name,
      targetIngredientId: dto.target_ingredient_id,
      targetIngredientName: dto.target_ingredient_name,
      batchQty: dto.batch_qty,
      yieldQtyProduced: dto.yield_qty_produced,
      businessDate: dto.business_date,
      note: dto.note,
      createdBy: dto.created_by,
      createdAt: dto.created_at,
    }
  },
}
